import React from "react";
import Box from "@mui/material/Box";
import { LocationData } from "types/models/master/MasterApp";
import { Fonts } from "shared/constants/AppEnums";



interface LocationProps {
  location: LocationData;
}

const LocationHeader: React.FC<LocationProps> = ({ location }) => {
 

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row" },
        pb: 5,
        mb: 2,
        borderBottom: "1px solid #E5E4EA",
      }}
    >
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Box
          component="h3"
          sx={{
            color: "text.primary",
            fontWeight: Fonts.BOLD,
            fontSize: 16,
            mb: 1,
          }}
        >
          {location ? "Edit Location" : "Add New Device Location"}
        </Box>
       
      </Box>
    </Box>
  );
};

export default LocationHeader;
